// extracted by mini-css-extract-plugin
module.exports = {"detailTable":"styles_detailTable__1GIA9","select":"styles_select__4FIZF"};